import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: [ './loading-spinner.component.scss' ],
})
export class LoadingSpinnerComponent implements OnInit
{
    @Input('loading-text') loadingText = null;
    @Input('has-text') hasText: boolean = true;

    public bars = [ 1, 2, 3, 4, 5, 6, 7, 8 ];

    constructor() { }

    ngOnInit(): void { }
}
